import { colors } from '@insurancemenu/imenu-components-lib';
import { ComponentStylesProps } from '@insurancemenu/imenu-components-lib/dist/types';
import { createUseStyles } from 'react-jss';
import { EnrollmentStage } from 'types/enrollmentService';

const styles: ComponentStylesProps<EnrollmentStage> = {
  tag: {
    lineHeight: '2rem',
    textAlign: 'center',
    color: colors.neutral[900],
    verticalAlign: 'middle',
    padding: '0.4rem 0rem',
    borderRadius: '14px',
  },
  tag_small: {
    fontSize: '1.2rem',
    width: '10rem',
    minWidth: '10rem',
  },
  tag_large: {
    fontSize: '1.4rem',
    width: '12rem',
  },
  // Invitation Statuses
  tagTypeNOT_YET_INVITED: { backgroundColor: colors.yellow[100] },
  tagTypeINVITED: { backgroundColor: colors.purple[100] },
  tagTypeADD_MAIL: { backgroundColor: colors.red[100] },
  tagTypeREGISTERED: { backgroundColor: colors.green[100] },
  tagTypeELECTED: { backgroundColor: colors.blue[100] },
  tagTypeACTIVE: { backgroundColor: colors.green[100] },
  tagTypeTERMINATED: { backgroundColor: colors.red[100] },
  // Roles
  tagTypeEMPLOYER: { backgroundColor: colors.orange[100] },
};

const createStyles = createUseStyles(styles);

export { createStyles };
